import styled from 'styled-components';

export const StyledSearchFieldContainer = styled.div<{
  isFocused: boolean;
}>`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.m};
  border-radius: ${({ theme }) => theme.spacing.s};
  border: 1px solid
    ${({ isFocused, theme }) =>
      isFocused
        ? theme.colorsInObjects.gray[900]
        : theme.colorsInObjects.gray[600]};
  background-color: ${({ isFocused, theme }) =>
    isFocused ? theme.colorsInObjects.gray[200] : theme.colors.white};
  display: flex;
  align-items: center;

  &:focus {
    background-color: ${({ theme }) => theme.colorsInObjects.gray[200]};
  }
`;

export const IconContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.xs};
`;

export const SearchFieldInput = styled.input`
  flex: 1;
  height: ${({ theme }) => theme.spacing.m};
  margin-right: ${({ theme }) => theme.spacing.s};
  border: none;
  background-color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.sm};
  outline: none;

  ::placeholder {
    color: ${({ theme }) => theme.colors.dimGray};
  }

  ::-ms-input-placeholder {
    color: ${({ theme }) => theme.colors.dimGray};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colorsInObjects.gray[200]};
  }
`;

export const StyledTextLabel = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;
